import React, { useEffect,useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchMainTurkishWebsites } from "../../redux/reducer/turkishWebsitesMainReducer";
import CustomLines from "../home/customLines";
import CustomBigText from "../sharedComponents/customBigText";
import CategoryCard from "./cardCategory";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";

const ChooseCategoryTrukeySection = () => {
const dispatch = useDispatch();
  // const navigate = useNavigate();
const navigateWithLang = useLanguageNavigate();

 const {t ,i18n} = useTranslation();
  // const staticImages = [ImageOne, ImageTwo, ImageThree, ImageFour, ImageFive, ImageSix];
  const { mainTurkishWebsites, status, error } = useSelector((state) => state.websites);
  
  const direction = useLanguageDirection();

  useEffect(() => {
    if (status === "idle" || !mainTurkishWebsites.length) {
      dispatch(fetchMainTurkishWebsites());
    }
  }, [dispatch, status, mainTurkishWebsites.length]);

  if (status === "loading") return <p>Loading...</p>;
  if (status === "failed") return <p className="text-red-500">Error: {error}</p>;
  if (!mainTurkishWebsites || mainTurkishWebsites.length === 0) return <p>{t("NoWebsites")}</p>;
  // console.log(mainTurkishWebsites)
  const handleCategoryClick = (name, websites) => {
    if (!websites || websites.length === 0) {
      console.error(t("NoWebsites"));
      return;
    }
    const formattedName = name.toLowerCase().replace(/\s+/g, "-");

     navigateWithLang(`/category-turkey/${encodeURIComponent(formattedName)}`, { state: { websites } });

     // Force a full page reload
     window.location.reload();
  };
  // console.log(mainTurkishWebsites)
  return (
    <div className=''>
      <div className="flex flex-col items-center justify-center text-center max-container">
        <CustomLines />
        <CustomBigText title={t("categoryTitle")}/>
        <div className="px-3 py-10">
          <div className="grid grid-cols-2 gap-6 sm:grid-cols-3 lg:grid-cols-6" dir={direction}>
            {mainTurkishWebsites.map((website, index) => {
              const title = i18n.language === "ar" ? website.title?.ar : website.title?.en;
              return (
                <div
                  key={website.id || website._id || index} // Fallback to index if no id is available
                  className="flex flex-col items-center cursor-pointer"
                  onClick={() => handleCategoryClick(website.title?.en, website.subCategory)}
                >
                  <CategoryCard
                    title={title || "Unnamed Website"}
                    image={website.img}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseCategoryTrukeySection;
